import { render, staticRenderFns } from "./Boleto.vue?vue&type=template&id=924fc0d2&scoped=true&"
import script from "./Boleto.vue?vue&type=script&lang=js&"
export * from "./Boleto.vue?vue&type=script&lang=js&"
import style0 from "./Boleto.vue?vue&type=style&index=0&id=924fc0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924fc0d2",
  null
  
)

export default component.exports